export default __webpack_public_path__ + "static/media/2.ca9c456a.png";